import React from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import SignupWidget from "./SignupWidget";

const SignupPage = ({ currentLocation, ...props }) => {
  return (
    <div className="create-container">
      <Helmet>
        <title>VegifyIt | Sign Up</title>
      </Helmet>
      <div style={{ width: "75vw" }}>
        <h2>Sign Up for a VegifyIt Account</h2>
        <p>
          Create an account to save searches, add restaurants, and more.
          We'll send you an invitation email shortly.
        </p>

        <SignupWidget />
      </div>
    </div>
  );
};
export default connect(() => {}, {})(SignupPage);
